import React, { createRef } from 'react';
import moment from 'moment';
import { withSnackbar } from "notistack";
import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import ListAltIcon from "@material-ui/icons/ListAlt";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from '@material-ui/core/Tooltip';
import Service from "../../../../config/networkutils";
import {
    employees_and_projects,
    ptdEmployeesLeave,
    prp_template_api_bulk_update
} from "../../../../config/apiList";
import { getCookie } from "../../../../utils/CookieHelper";
import {
    weekStartDates,
    weekStartDatesObject,
    changeItToMonday,
} from "../../../../utils/betweenDates";
import Box from '@material-ui/core/Box';
// import EmployeeProjectsSchedules from "./EmployeeProjectsSchedules";
import EmployeeProjectsSchedules from "../../ResourceLocation/EmployeeProjectsSchedules"
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import { Delete, Done } from '@material-ui/icons';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Table, TableBody, TableHead, Typography } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import DoneIcon from '@material-ui/icons/Done';
import InfoIcon from '@material-ui/icons/Info';
import { getPrimaryColor, getSecondaryColor } from '../../../Helper/CommonThings';

const token = getCookie("ptd_ts_token");
const months = { 0: 'January', 1: 'Febrauary', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August', 8: 'September', 9: 'October', 10: 'November', 11: 'December' }


const useStyles = (theme) => ({
    table: {
        minWidth: 650,
        "& .MuiTableCell-root": {
            borderLeft: "1px solid rgba(224, 224, 224, 1)"
        }
    },
    root: {
        // width: 'calc(100vw - 45px)',
        padding: '0px',
        marginLeft: '2px',
    },
    container: {
        maxHeight: 440,
    },
    sticky: {
        position: "sticky",
        left: 0,
        background: "#F8F8F8",
        boxShadow: "1px 2px 1px grey"
    },
    smallIcon: {
        padding: '5px'
    },
    weekStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    otherTasksBatchNormal: {
        width: '0',
        height: '0',
        borderTop: '15px solid transparent',
        borderBottom: '15px solid transparent',
        borderRight: '15px solid #E8E8E8',
        // position: 'absolute',
        // top: '0px',
        transform: 'rotate(45deg)',
    },
    otherTasksBatchData: {
        width: '0',
        height: '0',
        borderTop: '15px solid transparent',
        borderBottom: '15px solid transparent',
        borderRight: '15px solid red',
        // position: 'absolute',
        // top: '0px',
        transform: 'rotate(45deg)',
    },
    otInput: {
        width: '100%',
        marginTop: '30px'
    },
    blackIcon: {
        // background: '#ff2400',
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center'
        // background: 'red'
        fontSize: '0.9rem',
        position: 'relative',
        top: '2px',
        left: '80%',
    },

    redIcon: {
        fontSize: '0.9rem',
        position: 'relative',
        top: '2px',
        left: '80%',
        color: 'red'
    }
});


class EmployeeRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            allEmployeeSchedules: [],
            allRoles: [],
            rolesObj: {},
            allEmp: [],
            empObj: {},
            columns: [],
            allMonths: [],
            selectedEndDate: null,
            selectedStartDate: null,
            templateRoles: [],
            mountEmployeeProjectsSchedulesDialogUI: false,
            selectedEmployee: "",
            employeeSearchField: "",
            employeeSearchFieldRerender: false,
            rawEmployeeSchedules: [],
            tabcelEdit: { empIndex: null, weekIndex: 0, showInputBox: false },
            editedWeekObj: {},
            otherTaskOpen: false,
            OTDescription: '',
            otEmp: '',
            otweekdate: '',
            leaveEditable: false,
            rowSelected: false,
            bulkLeaveDialogOpen: false,
            leavesData: { all_dates: [], category_data: [] },
            tableLoading: false,
            dialogTitle: '',
            isCommentsEdit: false,
            isCommentsAdd: false,
            description: '',
            startDate: '',
            qty: 0.5,
        }
        this.childRef = createRef()
        this.refresh = this.refresh.bind(this)
        this.addAllocation = this.addAllocation.bind(this)
    }
    // state = {
    //     allEmployeeSchedules: [],
    //     allRoles: [],
    //     rolesObj: {},
    //     allEmp: [],
    //     empObj: {},
    //     columns: [],
    //     allMonths: [],
    //     selectedEndDate: null,
    //     selectedStartDate: null,
    //     templateRoles: [],
    //     mountEmployeeProjectsSchedulesDialogUI: false,
    //     selectedEmployee: "",
    //     employeeSearchField: "",
    //     employeeSearchFieldRerender: false,
    //     rawEmployeeSchedules: [],
    //     tabcelEdit: { empIndex: null, weekIndex: 0, showInputBox: false },
    //     editedWeekObj: {},
    //     otherTaskOpen: false,
    //     OTDescription: '',
    //     otEmp: '',
    //     otweekdate: '',
    //     leaveEditable: false,
    //     rowSelected: false,
    // }
    // this.refresh=this.refresh.bind(this)
    tableCellStyle = {
        backgroundColor: "#EDFAFF",
        width: '200px'
    }

    refresh() {
        if (this.props.refresh) {
            this.props.refresh()
        }
    }

    wc_hex_is_light(color) {
        if (color.toLowerCase() === '#fff') {
            return '#000000';
        }
        const hex = color.replace('#', '');
        const c_r = parseInt(hex.substr(0, 2), 16);
        const c_g = parseInt(hex.substr(2, 2), 16);
        const c_b = parseInt(hex.substr(4, 2), 16);
        const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
        if (brightness > 155) {
            return '#000000'
        } else {
            return '#ffffff'

        }
    }

    updateEmployeeModifiedSchedules = () => {
        Service.patch(prp_template_api_bulk_update, {
            headers: {
                Authorization: "Token " + token,
            },
            data: this.state.rawEmployeeSchedules,
        })
            .then((res) => {
                // this.props.updateTheUpdatedSchedules(this.state.rawEmployeeSchedules);
                this.props.enqueueSnackbar("Employee schedules Updated!", {
                    variant: "success",
                });
                if (this.props.refresh) {
                    this.props.refresh()
                }
                this.handleTablecellEditClose();
            })
            .catch((error) => {
                this.props.enqueueSnackbar("Updating employee schedules failed!", {
                    variant: "error",
                });
            });
    };

    findLowestFromDate = (project) => {
        let fromDate = [];
        for (let scdl = 0; scdl < project.shdl_data.length; scdl++) {
            if (fromDate.length >= 1) {
                if (
                    moment(project.shdl_data[scdl].from.slice(0, 10)).isSameOrBefore(
                        moment(fromDate[0].toISOString().slice(0, 10))
                    )
                ) {
                    // if the fromDate[0] date is higher than the iteration date remove the fromDate[0] and add the iterated date.
                    fromDate.pop();
                    fromDate.push(moment(project.shdl_data[scdl].from.slice(0, 10)));
                } else if (
                    moment(project.shdl_data[scdl].from.slice(0, 10)).isSameOrAfter(
                        moment(fromDate[0].toISOString().slice(0, 10))
                    )
                ) {
                    continue;
                }
            } else {
                fromDate.push(moment(project.shdl_data[scdl].from.slice(0, 10)));
            }
        }

        return fromDate;
    };

    findHighestToDate = (project) => {
        let toDate = [];
        for (let scdl = 0; scdl < project.shdl_data.length; scdl++) {
            if (toDate.length >= 1) {
                //   moment(toDate[0].toISOString().slice(0, 10))
                // ))
                if (
                    moment(project.shdl_data[scdl].to.slice(0, 10)).isSameOrAfter(
                        moment(toDate[0].toISOString().slice(0, 10))
                    )
                ) {
                    // if the toDate[0] date is higher than the iteration date remove the toDate[0] and add the iterated date.
                    toDate.pop();
                    toDate.push(moment(project.shdl_data[scdl].to.slice(0, 10)));
                } else if (
                    moment(project.shdl_data[scdl].to.slice(0, 10)).isSameOrBefore(
                        moment(toDate[0].toISOString().slice(0, 10))
                    )
                ) {
                    continue;
                }
            } else {
                toDate.push(moment(project.shdl_data[scdl].to.slice(0, 10)));
            }
        }

        return toDate;
    };

    applyQuantityToEveryWeek = (rawSchedules) => {
        let rawEmployeeScheduless = [...rawSchedules];
        for (
            // Iterating all the projects
            let project = 0;
            project < rawEmployeeScheduless.length;
            project++
        ) {
            let stDat = this.findLowestFromDate(rawEmployeeScheduless[project]);
            let enDat = this.findHighestToDate(rawEmployeeScheduless[project]);

            let allMondayDates = weekStartDatesObject(
                stDat.toString(),
                enDat.toString()
            );
            for (
                let shdl = 0;
                shdl < rawEmployeeScheduless[project].shdl_data.length;
                shdl++
            ) {
                // Iterating all the shdls

                for (let monday in allMondayDates) {
                    // Iterating all the monday dates for one shdl

                    if (
                        moment(monday, "DD/MM/YYYY").isSameOrAfter(
                            moment(
                                rawEmployeeScheduless[project].shdl_data[shdl].from.slice(0, 10),
                            )
                        ) &&
                        moment(monday, "DD/MM/YYYY").isSameOrBefore(
                            moment(
                                rawEmployeeScheduless[project].shdl_data[shdl].to.slice(0, 10)
                            )
                        )
                    ) {
                        allMondayDates[monday] =
                            Number(allMondayDates[monday]) +
                            Number(rawEmployeeScheduless[project].shdl_data[shdl].qty);
                    }
                }
            }
            rawEmployeeScheduless[project].dates = allMondayDates;
        }
        this.setState({ rawEmployeeSchedules: rawEmployeeScheduless }, () => {

            this.updateEmployeeModifiedSchedules();
        });



    };

    getEmployeeSchedules(id) {
        Service.get(employees_and_projects + `?is_archive=0&emp_id=${id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then((res) => {
                this.setState({
                    rawEmployeeSchedules: res.data,
                });
            })
            .catch((error) => {
                this.props.enqueueSnackbar("Getting employee projects failed!", {
                    variant: "error",
                });
            });
    }

    handleTablecellEdit = (e, empIndex, emp) => {
        this.getEmployeeSchedules(emp.employee_id)
        this.setState({ tabcelEdit: { empIndex, showInputBox: true } })
    }

    handleTablecellEditClose = () => this.setState({ tabcelEdit: { empIndex: null, showInputBox: false }, editedWeekObj: {} })

    handleProjectChange = (e, weekDate, crmId) => {
        let prevEditedWeekObj = { ...this.state.editedWeekObj }
        if (prevEditedWeekObj.hasOwnProperty(weekDate)) {

            if (prevEditedWeekObj[weekDate].hasOwnProperty(crmId)) {

                prevEditedWeekObj[weekDate][crmId] = parseFloat(e.target.value)
            } else {
                prevEditedWeekObj[weekDate] = { ...prevEditedWeekObj[weekDate], [crmId]: parseFloat(e.target.value) }

            }
        } else {
            prevEditedWeekObj = { ...prevEditedWeekObj, [weekDate]: { [crmId]: parseFloat(e.target.value) } }

        }

        this.setState({ editedWeekObj: prevEditedWeekObj })
    }

    submitEditedWeek = () => {
        // This function edit the allocated resources and call the functio apply quantity to every week.
        let editedWeekObj = { ...this.state.editedWeekObj }
        let allSchedules = [...this.state.rawEmployeeSchedules]

        for (let weekScheduleDate in editedWeekObj) {

            if (Object.keys(editedWeekObj[weekScheduleDate]).length !== 0) {
                for (let scheduleIdx = 0; scheduleIdx < allSchedules.length; scheduleIdx++) {
                    for (const key in editedWeekObj[weekScheduleDate]) {

                        if (allSchedules[scheduleIdx]["crm"] === parseInt(key)) {
                            for (let projectScheduleIndex = 0; projectScheduleIndex < allSchedules[scheduleIdx]['shdl_data'].length; projectScheduleIndex++) {

                                // Finding Monday date on the week 
                                let fromdate = changeItToMonday(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['from'].slice(0, 10))
                                let todate = changeItToMonday(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'].slice(0, 10))

                                // Resetting to monday date of the week 
                                allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['from'] = fromdate
                                allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'] = todate
                                if (fromdate === todate && fromdate === moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true)) {
                                    // if fromdate === todate and curent iterated date with fromdate or to date then add the quantity to that week
                                    allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['qty'] = editedWeekObj[weekScheduleDate][key]
                                }
                                else {

                                    let allweekdates = weekStartDates(moment(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['from'].slice(0, 10)), moment(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'].slice(0, 10)))
                                    // Otherwise split the already existing schedule and apply the quantity 

                                    if (moment(weekScheduleDate, 'DD/MM/YYYY').isSame(moment(fromdate.slice(0, 10)))) {

                                        allSchedules[scheduleIdx]['shdl_data'].push({ to: moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true), qty: editedWeekObj[weekScheduleDate][key], from: moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true) })
                                        allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['from'] = moment(allweekdates[allweekdates.indexOf(weekScheduleDate) + 1], 'DD/MM/YYYY').toISOString(true)

                                        // allSchedules[scheduleIdx]['shdl_data'].push({ to: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'], qty: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['qty'], from: moment(allweekdates[allweekdates.indexOf(weekScheduleDate) + 1], 'DD/MM/YYYY').toISOString(true) })
                                        // allSchedules[scheduleIdx]['shdl_data'].splice(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'], 1)
                                        break;
                                    } else if (moment(weekScheduleDate, 'DD/MM/YYYY').isSame(moment(todate.slice(0, 10)))) {

                                        // let allweekdates = weekStartDates(moment(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['from'].slice(0, 10)), moment(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'].slice(0, 10)))

                                        allSchedules[scheduleIdx]['shdl_data'].push({ to: moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true), qty: editedWeekObj[weekScheduleDate][key], from: moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true) })
                                        allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'] = moment(allweekdates[allweekdates.indexOf(weekScheduleDate) - 1], 'DD/MM/YYYY').toISOString(true)
                                        // allSchedules[scheduleIdx]['shdl_data'].push({ to: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'], qty: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['qty'], from: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'] })
                                        break;
                                    }
                                    else if (moment(weekScheduleDate, 'DD/MM/YYYY').isSameOrAfter(moment(fromdate.slice(0, 10))) && moment(weekScheduleDate, 'DD/MM/YYYY').isSameOrBefore(moment(todate.slice(0, 10)))) {

                                        // let allweekdates = weekStartDates(moment(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['from'].slice(0, 10)), moment(allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'].slice(0, 10)))
                                        allSchedules[scheduleIdx]['shdl_data'].push({ to: moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true), qty: editedWeekObj[weekScheduleDate][key], from: moment(weekScheduleDate, 'DD/MM/YYYY').toISOString(true) })
                                        allSchedules[scheduleIdx]['shdl_data'].push({ to: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'], qty: allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['qty'], from: moment(allweekdates[allweekdates.indexOf(weekScheduleDate) + 1], 'DD/MM/YYYY').toISOString(true) })
                                        allSchedules[scheduleIdx]['shdl_data'][projectScheduleIndex]['to'] = moment(allweekdates[allweekdates.indexOf(weekScheduleDate) - 1], 'DD/MM/YYYY').toISOString(true)
                                        break;
                                    }
                                }

                            }

                        }
                    }
                }
                // apply qty to all week dates
                // call the backend
            }
            else if (Object.keys(editedWeekObj[weekScheduleDate]).length === 0) {

                this.handleTablecellEditClose();
            }
        }
        this.setState({ rawEmployeeSchedules: allSchedules, editedWeekObj: {} }, this.applyQuantityToEveryWeek(allSchedules))
        // this.setState({ rawEmployeeSchedules: allSchedules, editedWeekObj: {} })



    }

    mountEmployeeWorkSchedules = (selectedEmployee, index) => {
        this.setState({ mountEmployeeProjectsSchedulesDialogUI: true });
        this.setState({ selectedEmployee, selectedIndex: index });
    };

    makeReportForOneEmployee(empProjectsArray) {

        const startOfMonth = this.state.selectedStartDate ? moment(this.state.selectedStartDate).startOf('month') : moment().subtract(4, 'months').startOf('month');
        const endOfMonth = this.state.selectedEndDate ? moment(this.state.selectedEndDate).endOf('month') : moment().add(12, 'months').endOf('month');


        let startDate = moment(startOfMonth)//moment('2012-04-01');
        let endDate = moment(endOfMonth)//moment('2014-11-01');

        let result = [];

        if (endDate.isBefore(startDate)) {
            throw new Error("End date must be greated than start date.")
        }

        while (startDate.isBefore(endDate)) {
            result.push(months[startDate.month()] + ' ' + startDate.year());
            startDate.add(1, 'month');
        }

        let allWeekDates = weekStartDates(startOfMonth, endOfMonth);


        let final = []
        let colspan = 1;
        for (let i = 0; i < allWeekDates.length; i++) {

            let date = moment(allWeekDates[i], 'DD/MM/YYYY')
            let monthYear = months[date.month()] + ' ' + date.year()
            if (!result.length) {
                result.push(monthYear)
                final.push({ month: monthYear, colSpan: colspan })
            }
            else {
                if (result[result.length - 1] === monthYear) {
                    colspan += 1
                    final[final.length - 1]['colSpan'] = colspan
                }
                else {
                    colspan = 1
                    result.push(monthYear)
                    final.push({ month: monthYear, colSpan: colspan })
                }
            }

        }
        // let empObj = {}
        let employeeRowData;
        //let newData = { [this.state.allEmp[i].id]: this.state.allEmp[i].first_name + ' ' + this.state.allEmp[i].last_name }
        // empobj = { ...empobj, ...newData }
        let newEle = this.props.emp
        let weeks = [];
        let weekdata = []
        for (let j = 0; j < empProjectsArray.length; j++) {
            // if (this.state.allEmp[i].job_title === this.props.data.id && empProjectsArray[j].role_id === this.props.data.id) {
            // allWeekDates.forEach(date => {
            for (let m = 0; m < allWeekDates.length; m++) {
                let date = allWeekDates[m];
                if (empProjectsArray[j].dates) {
                    if (empProjectsArray[j].dates.hasOwnProperty(date) && empProjectsArray[j].dates[date] !== 0) {
                        if (weeks.indexOf(date) === -1) {
                            newEle = { ...newEle, [date]: empProjectsArray[j].crm }
                            weeks.push(date);
                            weekdata.push({ name: [empProjectsArray[j].crm_name], project_code: [this.props.projectObj[empProjectsArray[j].crm]['project_code']], crmId: [empProjectsArray[j].crm], crm_color_code: [empProjectsArray[j].crm_color_code], })
                        } else {
                            // If already a project in the week then concatenate the date
                            if (weekdata[weeks.indexOf(date)]['name'] !== "") {
                                weekdata[weeks.indexOf(date)]['name'].push(empProjectsArray[j].crm_name)
                                weekdata[weeks.indexOf(date)]['project_code'].push(this.props.projectObj[empProjectsArray[j].crm]['project_code'])
                                weekdata[weeks.indexOf(date)]['crmId'].push(empProjectsArray[j].crm)
                                weekdata[weeks.indexOf(date)]['crm_color_code'].push(empProjectsArray[j].crm_color_code)
                                // weekdata[weeks.indexOf(date)] +
                                // "\n , \n" +
                                // this.props.projectObj[empProjectsArray[j].crm];

                            } else if (weekdata[weeks.indexOf(date)]['name'] === "") {
                                weekdata[weeks.indexOf(date)]['name'].push(this.props.projectObj[empProjectsArray[j].crm])
                                weekdata[weeks.indexOf(date)]['project_code'].push(this.props.projectObj[empProjectsArray[j].crm]['project_code'])
                                weekdata[weeks.indexOf(date)]['crmId'].push(empProjectsArray[j].crm)
                                weekdata[weeks.indexOf(date)]['crm_color_code'].push(empProjectsArray[j].crm_color_code)
                                // weekdata[weeks.indexOf(date)] =
                                //   weekdata[weeks.indexOf(date)] +
                                //   this.props.projectObj[empProjectsArray[j].crm];
                            }
                        }
                    }
                    else {
                        newEle = { ...newEle, [date]: '' }
                        weeks.push(date);
                        weekdata.push({ name: [], crmId: [], project_code: [], crm_color_code: [] })
                    }
                }


            }
            // }
        }
        newEle['weeks'] = weeks;
        newEle['weekdata'] = weekdata
        // if (this.state.allEmp[i].job_title === this.props.data.id && newEle.weekdata.length > 0) {
        if (newEle.weekdata.length > 0) {
            let notEmpty = newEle.weekdata.filter((week => week['name'].length > 0))
            // if all weekdata strings are empty then fiter it out
            if (notEmpty.length > 1 && moment(newEle.end_date).isAfter(moment().format())) {
                // if (notEmpty.length > 1){
                employeeRowData = newEle
            }
        }
        employeeRowData = newEle
        // let columns = []
        // // columns.push({ title: 'Employee', field: 'id', lookup: empobj })
        // for (let i = 0; i < allWeekDates.length; i++) {
        //   let newObj = {
        //     title: moment(allWeekDates[i], 'DD/MM/YYYY').format('DD MMM'),
        //     field: allWeekDates[i],
        //     type: 'number',
        //     width: 150,
        //     sorting: false,
        //     editable: 'never',
        //     filtering: false
        //   }
        //   columns.push(newObj)
        // }
        this.props.updateEmployeeRow(employeeRowData)
        // this.setState({ allEmpCopy: filterEmp, allEmp: filterEmp, columns, allMonths: final })
        // return employeeRowData
    }

    includeLeaves(leavesArray) {
        let allEmployeeSchedules = [...this.props.emp.weekdata]
        let columns = [...this.props.columns]
        for (let leaveindex = 0; leaveindex < leavesArray.length; leaveindex++) {
            for (let colindex = 0; colindex < columns.length; colindex++) {
                // let date = moment(columns[colindex]['field'], 'DD/MM/YYYY').toISOString().slice(0, 10)
                let date = moment(columns[colindex]['field'], 'DD/MM/YYYY').format('YYYY-MM-DD')
                if (leavesArray[leaveindex]['date'] === date) {
                    allEmployeeSchedules[colindex].leaves = leavesArray[leaveindex]
                }
            }

        }
        return allEmployeeSchedules
    }

    getLeaveData(emp) {
        // let startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        Service.get(`/api/ptd/employees/leave/get_emp_leaves_data/?emp_id=${(this.props.emp).hasOwnProperty('employee_id') ? (this.props.emp).employee_id : (this.props.emp).id}&start_date=${this.state.startDate}&change_report_type=${this.props.type}&is_active=True`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then((res) => {
                this.setState({
                    leavesData: res.data,
                    tableLoading: false
                })

            })
            .catch((error) => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: "error",
                });
            });
    }

    openAddLeaveDialog(weekIndex, emp) {
        //eslint-disable-next-line no-useless-concat
        this.setState({ startDate: this.props.columns[weekIndex]['field'], bulkLeaveDialogOpen: true, weekIndex, tableLoading: true, dialogTitle: this.props.emp.first_name + ' ' + this.props.emp.last_name + ' - ' + this.props.columns[weekIndex]['field'] }, () => {
            this.getLeaveData(emp)
        })
        // this.setState({ selectedOtherTask: '', otherTaskOpen: true, OTDescription: '', otweekdate: this.props.columns[weekIndex]['field'] })
    }

    openEditLeaveDialog(weekIndex, id) {
        this.setState({ selectedOtherTask: this.state.allEmployeeSchedules[weekIndex]['leaves']['other_tasks'], OTDescription: this.state.allEmployeeSchedules[weekIndex]['leaves']['comments'], otherTaskOpen: true, otweekdate: this.props.columns[weekIndex]['field'], leaveEditable: true, leaveEditId: id, editWeekIndex: weekIndex })
    }

    otPostOps() {
        let emp_id = (this.props.emp).hasOwnProperty('employee_id') ? (this.props.emp).employee_id : (this.props.emp).id
        let date = moment(this.state.otweekdate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        let data = {
            ptd_employee: emp_id,
            other_tasks: this.state.selectedOtherTask,
            date,
            comments: this.state.OTDescription,
        };

        Service.post(ptdEmployeesLeave + '?user=' + emp_id, {
            headers: {
                Authorization: "Token " + token,
            }, data
        }).then(res => {
            let dupOTs = [...this.state.allLeaves, res.data]
            let revisedSchedules = this.includeLeaves(dupOTs)
            this.setState({ allLeaves: dupOTs, otherTaskOpen: false, allEmployeeSchedules: revisedSchedules, selectedOtherTask: '', OTDescription: '', otweekdate: '' })
            this.props.enqueueSnackbar('Leave created', { variant: 'success' })

        }).catch(error => {
            this.props.enqueueSnackbar('Creating Leave failed retry!', { variant: 'error' })
        })
    }

    otPutOps() {
        let emp_id = (this.props.emp).hasOwnProperty('employee_id') ? (this.props.emp).employee_id : (this.props.emp).id
        let date = moment(this.state.otweekdate, 'DD/MM/YYYY').toISOString().format('YYYY-MM-DD')
        let data = {
            ptd_employee: emp_id,
            other_tasks: this.state.selectedOtherTask,
            date,
            comments: this.state.OTDescription,
        };

        Service.put(ptdEmployeesLeave + this.state.leaveEditId + "/", {
            headers: {
                Authorization: "Token " + token,
            }, data
        }).then(res => {
            let dupOTs = [...this.state.allLeaves, res.data]
            let revisedSchedules = this.includeLeaves(dupOTs)
            this.setState({ allLeaves: dupOTs, otweekdate: '', otherTaskOpen: false, allEmployeeSchedules: revisedSchedules, leaveEditable: false, leaveEditId: '', selectedOtherTask: '', OTDescription: '' })
            this.props.enqueueSnackbar('Leave Updated', { variant: 'success' })

        }).catch(error => {
            this.props.enqueueSnackbar('Updating Leave failed retry!', { variant: 'error' })
        })
    }

    otDelOps() {
        Service.delete(ptdEmployeesLeave + this.state.leaveEditId + "/", {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            let dupOTs = [...this.state.allLeaves]
            dupOTs = dupOTs.filter(leav => leav.id !== this.state.leaveEditId)
            let revisedSchedules = [...this.state.allEmployeeSchedules]
            delete revisedSchedules[this.state.editWeekIndex]['leaves']
            this.setState({ allLeaves: dupOTs, otweekdate: '', otherTaskOpen: false, allEmployeeSchedules: revisedSchedules, leaveEditable: false, leaveEditId: '', selectedOtherTask: '', OTDescription: '' })
            this.props.enqueueSnackbar('Leave Deleted', { variant: 'success' })

        }).catch(error => {
            this.props.enqueueSnackbar('Deleting Leave failed retry!', { variant: 'error' })
        })
    }

    scroll() {
        this.childRef.current.scrollIntoView({ behavior: 'smooth' });
    }


    componentDidMount() {

        let { selectedStartDate, selectedEndDate, allEmployeesLeaves, } = this.props;
        let emp_id = (this.props.emp).hasOwnProperty('employee_id') ? (this.props.emp).employee_id : (this.props.emp).id
        let currentEmployeesLeaves = allEmployeesLeaves.filter(leave => leave.ptd_employee === emp_id)
        let allEmployeeSchedules = this.includeLeaves(currentEmployeesLeaves);
        this.setState({ selectedStartDate, selectedEndDate, allEmployeeSchedules, allLeaves: currentEmployeesLeaves })

    }

    componentDidUpdate(prevProps) {
        if (prevProps.allEmployeesLeaves !== this.props.allEmployeesLeaves) {
            let emp_id = this.props.emp.hasOwnProperty('employee_id') ? this.props.emp.employee_id : this.props.emp.id
            let currentEmployeesLeaves = this.props.allEmployeesLeaves.filter(leave => leave.ptd_employee === emp_id)
            let allEmployeeSchedules = this.includeLeaves(currentEmployeesLeaves)
            this.setState({ allEmployeeSchedules, allLeaves: currentEmployeesLeaves })
        }
    }

    addAllocation(emp, prj) {
        if (this.props.addAllocation) {
            this.props.addAllocation(emp, prj)
            this.setState({ mountEmployeeProjectsSchedulesDialogUI: false })
        }
    }

    assignNewLeave = (task, date, popupState) => {
        if (this.state.description.length === 0) {
            this.props.enqueueSnackbar('Please enter description', { variant: 'warning' })
            return
        } else {
            let data = {
                emp_id: (this.props.emp).hasOwnProperty('employee_id') ? (this.props.emp).employee_id : (this.props.emp).id,
                leave_details: [{
                    date: date,
                    other_tasks: task.id,
                    comments: this.state.description,
                    quantity: this.state.qty
                }]
            }
            Service.post('/api/ptd/employees/leave/bulk_create_emp_leaves/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            }).then(res => {
                popupState.close()
                this.props.enqueueSnackbar('Leave created', { variant: 'success' })
                this.setState({ isCommentsAdd: false, description: '', qty: 0.5 })
                this.getLeaveData(this.props.emp)
                this.updateColor()
            }).catch(error => {
                console.log(error)
                if (error && error.status === 406) {
                    this.props.enqueueSnackbar(error.data.message, { variant: 'warning' })
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
                }
            })
        }
    }

    deleteLeave = (data) => {
        Service.delete('/api/ptd/employees/leave/' + data.id + '/', {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            this.props.enqueueSnackbar('Leave deleted', { variant: 'success' })
            this.getLeaveData(this.props.emp)
            this.updateColor()
        }).catch(error => {
            this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
        })
    }

    editDescription = (data) => {
        if (this.state.description.length === 0) {
            this.props.enqueueSnackbar('Please enter description', { variant: 'warning' })
            return
        } else {
            data.date = moment(data.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
            data.comments = this.state.description
            data.quantity = this.state.qty
            data.emp_id = (this.props.emp).hasOwnProperty('employee_id') ? (this.props.emp).employee_id : (this.props.emp).id
            Service.patch('/api/ptd/employees/leave/update_quantity/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            }).then(res => {
                this.props.enqueueSnackbar('Description Edited Successfully!', { variant: 'success' })
                this.setState({
                    isCommentsEdit: false,
                    qty: 0.5
                })
                this.getLeaveData(this.props.emp)
                this.updateColor()
            }).catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
            })
        }
    }

    updateColor() {
        var input = {
            emp_id: this.props.emp.employee_id,
            date: this.props.columns[this.state.weekIndex]['field'],
            view_type: this.props.type
        }

        Service.post('/api/ptd/employees/leave/get_employee_leave_by_view_type/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: input
        }).then(res => {
            var allEmployeeSchedules = this.state.allEmployeeSchedules
            allEmployeeSchedules[this.state.weekIndex].leave = res.data.leave_code
            this.setState({ allEmployeeSchedules: allEmployeeSchedules })
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
        })
    }


    render() {

        const handleBulkLeaveDialogClose = () => {
            this.setState({ bulkLeaveDialogOpen: false });
        };

        const handleDescriptionChange = (e) => {
            this.setState({ description: e.target.value })
        }

        const classes = this.props.classes;
        const { index, emp, columns } = this.props;
        return (<TableRow key={index} ref={this.childRef}>
            <TableCell colSpan={2} width={50} className={classes.sticky} style={{ zIndex: 99 }} align="center">
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Box display="flex" flexDirection="row" alignItems="center">
                        <Checkbox checked={emp.is_checked === true} onChange={
                            (e) => {
                                this.props.updateSelected(emp, e.target.checked)
                            }}
                            size="small"></Checkbox>
                        <IconButton
                            aria-label="close"
                            variant="outlined"
                            color="primary"
                            onClick={(e) =>
                                this.mountEmployeeWorkSchedules(emp, index)
                            }
                        >
                            <ListAltIcon />
                        </IconButton>

                        {this.state.tabcelEdit['showInputBox'] && this.state.tabcelEdit['empIndex'] === index ?
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <IconButton className={classes.smallIcon} onClick={this.handleTablecellEditClose}>
                                    <CloseIcon />
                                </IconButton>
                                <IconButton className={classes.smallIcon} onClick={this.submitEditedWeek}>
                                    <DoneAllIcon />
                                </IconButton>
                            </Box>
                            : null}
                        {/* {this.state.tabcelEdit['showInputBox'] && this.state.tabcelEdit['empIndex'] === index ? null : <IconButton style={{ padding: '10px' }} onClick={(e) => this.handleTablecellEdit(e, index, emp)}  ><EditIcon /></IconButton>} */}
                    </Box>

                    {/* <Box style={{ borderLeft: '1px solid' }}> */}
                    <Box>
                        <span >{emp.first_name + ' ' + emp.last_name}</span>
                    </Box>
                </Box>
            </TableCell>
            <TableCell width={80} style={{ background: "#F8F8F8", position: "sticky", left: '300px', zIndex: 99 }}>
                <Box display="flex" flexDirection="row" alignItems="center" justifyContent={'center'}>
                    <span >{emp.employee_no}</span>
                </Box>
            </TableCell>
            <TableCell width={120} style={{ background: "#F8F8F8", position: "sticky", left: '450px', zIndex: 99 }}>
                <span style={{ color: getPrimaryColor() }}>{emp.role_name}</span>&nbsp;/&nbsp;<span style={{ color: getSecondaryColor() }}>{emp.allocated_role}</span>
            </TableCell>
            {
                this.state.allEmployeeSchedules.map((aweek, weekIndex) => {

                    return <TableCell key={weekIndex} className={classes.root} style={this.state.tabcelEdit['empIndex'] === index ? this.tableCellStyle : { width: '200px' }} >

                        {
                            // this.state.tabcelEdit['empIndex'] === index ? <span>{""}</span> :
                            <div>
                                {
                                    // aweek['leaves'] ?
                                    //     <Tooltip title={
                                    //         <div>
                                    //             <dl style={{ fontSize: '0.8rem' }}>
                                    //                 <dt style={{ marginBottom: '5px', fontWeight: 'bold' }}>{this.props.othertaskObject[aweek['leaves'].other_tasks]}</dt>
                                    //                 <dd>{aweek['leaves'].comments}</dd>
                                    //             </dl>
                                    //         </div>}>
                                    //         <span onClick={() => this.openAddLeaveDialog(weekIndex, aweek)}>
                                    //             <AssignmentLateIcon className={classes.redIcon} />
                                    //         </span>
                                    //     </Tooltip> :
                                    <Tooltip title={'Create Leave'}>
                                        <span onClick={() => this.openAddLeaveDialog(weekIndex, aweek)}>
                                            <AssignmentLateIcon fontSize='0.8rem' style={{ color: Array.isArray(aweek['leave']) && aweek['leave'].length > 0 ? aweek['leave'][0] : aweek['leave'] ? aweek['leave'] : '#000' }} />
                                        </span>
                                    </Tooltip>
                                }
                                <div>
                                                    {(aweek['project_code'] || []).map((pk, pkIndex) =>
                                        <Tooltip key={pkIndex} title={<span style={{ fontSize: '0.8rem' }}>{aweek['name'][pkIndex]}{aweek['shdl_data'] ? aweek?.shdl_data[0].work_type ? ` - ${this.props.work_TypeFullObj[aweek?.shdl_data[0].work_type]}` : null : null}</span>} arrow>
                                            <p style={{ background: aweek['crm_color_code'][pkIndex] ? aweek['crm_color_code'][pkIndex] : "#fff", color: aweek['crm_color_code'][pkIndex] ? this.wc_hex_is_light(aweek['crm_color_code'][pkIndex]) : "#000" }}>{pk ? pk : aweek['name'][pkIndex]}{aweek['shdl_data'] ? aweek?.shdl_data[0].work_type ? `  (${this.props.work_typeObj[aweek?.shdl_data[0].work_type]})` : null : null}</p>
                                        </Tooltip>
                                    )}
                                </div>
                            </div>
                        }
                        {this.state.tabcelEdit['showInputBox'] && this.state.tabcelEdit['empIndex'] === index ?
                            <div className={classes.weekStyles}>
                                {(aweek['project_code'] || []).map((project, projIndex) => (
                                    <Tooltip key={projIndex} placement='right-end' title={<span style={{ fontSize: '0.8rem' }}>{aweek['name'][projIndex]}</span>}>
                                        <TextField
                                            autoComplete='off'
                                            style={{ width: '2rem' }}
                                            key={projIndex}
                                            type="number"
                                            id="standard-basic"
                                            label={project}
                                            placeholder={project ? project : aweek['name'][projIndex]}
                                            onChange={(e) => this.handleProjectChange(e, columns[weekIndex]['field'], aweek['crmId'][projIndex])}
                                        />
                                    </Tooltip>
                                ))}
                            </div>
                            : null}

                    </TableCell>

                })
            }
            <div />
            {/* {
                this.state.mountEmployeeProjectsSchedulesDialogUI ?
                    <EmployeeProjectsSchedules
                        refresh={this.refresh}
                        employee={this.state.selectedEmployee}
                        roleId={this.props.role ? this.props.role : this.state.selectedEmployee.job_title}
                        allProjects={this.props.allProjects}
                        allRoles={this.props.allRoles}
                        // projectObj={this.props.projectObj}
                        updateTheUpdatedSchedules={(empArray) =>
                            this.MakeReportForOneEmployee(empArray)
                        }
                        employeeUpdate={(updatedEmployeeData) => {
                            this.setState({
                                selectedIndex: "",
                                mountEmployeeProjectsSchedulesDialogUI: false,
                            });
                        }}
                        unmountMe={() => {
                            this.setState({
                                ...this.state,
                                mountEmployeeProjectsSchedulesDialogUI: false,
                                selectedEmployee: "",
                            });
                        }}
                    /> : null

            } */}
            {
                this.state.mountEmployeeProjectsSchedulesDialogUI ? (
                    <EmployeeProjectsSchedules
                        refreshData={this.refresh}
                        reload={this.refresh}
                        employee={this.state.selectedEmployee}
                        roleId={this.props.role ? this.props.role : this.state.selectedEmployee.job_title}
                        allProjects={this.props.allProjects}
                        allRoles={this.props.allRoles}
                        liveOpportunities={this.props.liveOpportunities}
                        disciplineObj={this.props.disciplineObj}
                        updateTheUpdatedSchedules={(empArray) =>
                            this.makeReportForOneEmployee(empArray)
                        }
                        employeeUpdate={(updatedEmployeeData) => {
                            this.setState({
                                selectedIndex: "",
                                mountEmployeeProjectsSchedulesDialogUI: false,
                            });
                        }}
                        unmountMe={() => {
                            this.setState({
                                ...this.state,
                                mountEmployeeProjectsSchedulesDialogUI: false,
                                selectedEmployee: "",
                            });
                        }}
                        unMountRefresh={() => {
                            this.setState({
                                ...this.state,
                                mountEmployeeProjectsSchedulesDialogUI: false,
                                selectedEmployee: "",
                            });
                            this.refresh()
                        }}
                        addAllocation={this.addAllocation}
                    />
                ) : null
            }
            < Dialog
                open={this.state.otherTaskOpen} onClose={() => this.setState({ otherTaskOpen: false })}>
                <DialogTitle>{'Add Other Task'}</DialogTitle>
                <DialogContent>

                    <FormControl required variant="filled" className={classes.otInput}>
                        <InputLabel id="demo-simple-select-outlined-label">Other Tasks</InputLabel>
                        <Select
                            labelId="demo-simple-select-outlined-label"
                            value={this.state.selectedOtherTask}
                            onChange={(e) => this.setState({ selectedOtherTask: e.target.value })}
                            autoWidth={true}
                        >
                            <MenuItem value=''>None</MenuItem>
                            {this.props.allOtherTasks.map((task, taskIndex) =>
                                <MenuItem key={taskIndex} value={task.id}>{task.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField
                        className={classes.otInput}
                        id="description"
                        label="Description"
                        value={this.state.OTDescription}
                        onChange={(e) => this.setState({ OTDescription: e.target.value })}
                        variant="outlined"
                        fullWidth={true}
                        multiline
                        rows={5}
                    />

                </DialogContent>
                <DialogActions>
                    {this.state.leaveEditable ? <>
                        <IconButton onClick={(e) => this.otPutOps()}><Done /></IconButton> <IconButton onClick={(e) => {
                            this.otDelOps()
                        }}>
                            <Delete /></IconButton>
                    </>
                        : <IconButton onClick={(e) => this.otPostOps()}><Done /></IconButton>}

                </DialogActions>
            </Dialog >
            <Dialog open={this.state.bulkLeaveDialogOpen} onClose={handleBulkLeaveDialogClose} maxWidth={'md'} fullWidth={true}>
                <DialogTitle>
                    <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' margin='3px'>
                        <Typography>{this.state.dialogTitle}</Typography>
                        <IconButton onClick={handleBulkLeaveDialogClose}><CloseIcon color='error' /></IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {this.state.tableLoading ? <Box width='100%' display={'flex'} justifyContent={'center'} alignItems={'center'}><CircularProgress /></Box> :
                        <Box margin='10px' style={{ overflowY: 'scroll', overflowX: 'auto' }}>
                            <Box minWidth={'100px'} maxHeight={window.innerHeight - 200} >
                                <Table style={{ height: '100px', overFlowX: 'auto' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.sticky} style={{ zIndex: 999 }} align="center">
                                                Categories
                                            </TableCell>
                                            {this.state?.leavesData?.all_dates.map((date, dateIndex) => {
                                                return <TableCell key={dateIndex} className={classes.sticky} style={{ zIndex: 99 }} align="center">
                                                    {this.state?.leavesData?.holiday_leaves?.[date] ?
                                                        <Box display='flex' flexDirection='column' alignItems='center'>
                                                            <Box>{date}</Box>
                                                            <Box style={{ color: 'red' }}>{this.state?.leavesData?.holiday_leaves?.[date]}</Box>
                                                        </Box>
                                                        :
                                                        <Box>{date}</Box>
                                                    }
                                                </TableCell>
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state?.leavesData?.category_data.map((task, taskIndex) =>
                                            <TableRow key={taskIndex} value={task.id}>
                                                <TableCell className={classes.sticky} style={{ zIndex: 99 }} align="center">
                                                    {task.name}
                                                </TableCell>
                                                {this.state.leavesData?.all_dates.map((date, dateIndex) => {
                                                    const isBankHoliday = Boolean(this.state?.leavesData?.holiday_leaves?.[date]);
                                                    return <TableCell>
                                                        {task.leaves.find(user => user.date === date) ?
                                                            <Box width='100%' display='flex' justifyContent='center' alignItems='center'>
                                                                <PopupState variant="popover" popupId="demo-popup-popover">
                                                                    {(popupState) => (
                                                                        <div>
                                                                            <InfoIcon
                                                                                fontSize='small'
                                                                                color={isBankHoliday ? 'disabled' : 'primary'}
                                                                                style={isBankHoliday ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
                                                                                {...(isBankHoliday ? {} : bindTrigger(popupState))}
                                                                            />
                                                                            <Popover
                                                                                {...bindPopover(popupState)}
                                                                                anchorOrigin={{
                                                                                    vertical: 'bottom',
                                                                                    horizontal: 'center',
                                                                                }}
                                                                                transformOrigin={{
                                                                                    vertical: 'top',
                                                                                    horizontal: 'center',
                                                                                }}
                                                                            >
                                                                                <Box p={2}>
                                                                                    <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                                                        <Box display='flex' flexDirection='column' alignItems={'center'} flexGrow={1}>
                                                                                            {this.state.isCommentsEdit ?
                                                                                                <Box display='flex' flexDirection='column' alignItems={'center'} >
                                                                                                    <TextField
                                                                                                        label="Description"
                                                                                                        placeholder="Description"
                                                                                                        variant="outlined"
                                                                                                        size='small'
                                                                                                        defaultValue={this.state.description}
                                                                                                        onChange={handleDescriptionChange} />

                                                                                                    <Box width={'100%'}>
                                                                                                        <FormControl variant="outlined" size='small' style={{ minWidth: '100%', marginTop: '10px' }}>
                                                                                                            <InputLabel htmlFor="outlined-age-native-simple">Qty</InputLabel>
                                                                                                            <Select
                                                                                                                native
                                                                                                                size='small'
                                                                                                                value={this.state.qty}
                                                                                                                onChange={(e) => this.setState({ qty: e.target.value })}
                                                                                                                label="Qty"
                                                                                                                fullWidth={true}
                                                                                                                style={{ marginTop: '10px', width: '100%' }}
                                                                                                                inputProps={{
                                                                                                                    name: 'qty',
                                                                                                                    id: 'outlined-age-native-simple',
                                                                                                                }}
                                                                                                            >
                                                                                                                <option value={0.5}>0.5</option>
                                                                                                                <option value={1}>1</option>
                                                                                                            </Select>
                                                                                                        </FormControl>
                                                                                                    </Box>
                                                                                                </Box>
                                                                                                :
                                                                                                <Box>
                                                                                                    <b>Description: </b>{task.leaves.find(user => user.date === date).comments}<br />
                                                                                                    <b>Quantity: </b> {task.leaves.find(user => user.date === date).quantity}
                                                                                                </Box>}
                                                                                        </Box>
                                                                                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                                                            <Box marginLeft={'5px'}>{this.state.isCommentsEdit ? <Box><DoneIcon color='primary' onClick={() => this.editDescription(task.leaves.find(user => user.date === date))} /><CloseIcon color='secondary' onClick={() => { popupState.close(); this.setState({ description: '' }) }} /></Box> : <EditIcon color='primary' onClick={() => this.setState({ qty: task.leaves.find(user => user.date === date).quantity, description: task.leaves.find(user => user.date === date).comments, isCommentsEdit: true })} />}</Box>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Box>
                                                                            </Popover>
                                                                        </div>
                                                                    )}
                                                                </PopupState>
                                                            </Box> : null}
                                                        <PopupState variant="popover" popupId="demo-popup-popover">
                                                            {(popupState) => (
                                                                <div>
                                                                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                                        {task.leaves.find(user => user.date === date) ?
                                                                            <span style={isBankHoliday ? { cursor: 'not-allowed', display: 'inline-flex' } : { display: 'inline-flex' }}>
                                                                                <Checkbox
                                                                                    disabled={isBankHoliday}
                                                                                    size='small' checked={task.leaves?.find(user => user.date === date)}
                                                                                    onChange={() => this.deleteLeave(task.leaves.find(user => user.date === date))}
                                                                                />
                                                                            </span> :
                                                                            <span style={isBankHoliday ? { cursor: 'not-allowed', display: 'inline-flex' } : { display: 'inline-flex' }}>
                                                                                <Checkbox
                                                                                    size='small'
                                                                                    disabled={isBankHoliday}
                                                                                    checked={false} {...(isBankHoliday ? {} : bindTrigger(popupState))}
                                                                                    onChange={(e) => { this.setState({ isCommentsAdd: true }) }} />
                                                                            </span>}
                                                                        <Box>
                                                                            {task.leaves.find(user => user.date === date) ? task.leaves.find(user => user.date === date).quantity : null}
                                                                        </Box>
                                                                    </Box>

                                                                    <Popover
                                                                        {...bindPopover(popupState)}
                                                                        anchorOrigin={{
                                                                            vertical: 'bottom',
                                                                            horizontal: 'center',
                                                                        }}
                                                                        transformOrigin={{
                                                                            vertical: 'top',
                                                                            horizontal: 'center',
                                                                        }}
                                                                    >
                                                                        <Box p={2}>
                                                                            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                                                <Box display='flex' flexDirection='column' alignItems={'center'}>
                                                                                    <Box>{this.state.isCommentsAdd ?
                                                                                        <TextField
                                                                                            label="Description"
                                                                                            placeholder="Description"
                                                                                            size='small'
                                                                                            variant="outlined"
                                                                                            defaultValue={task.leaves?.find(user => user.date === date)?.comments}
                                                                                            onChange={handleDescriptionChange} /> : task.leaves?.find(user => user.date === date)?.comments}</Box>
                                                                                    <Box width={'100%'}>
                                                                                        <FormControl variant="outlined" size='small' style={{ minWidth: '100%', marginTop: '10px' }}>
                                                                                            <InputLabel htmlFor="outlined-age-native-simple">Qty</InputLabel>
                                                                                            <Select
                                                                                                native
                                                                                                size='small'
                                                                                                value={this.state.qty}
                                                                                                onChange={(e) => this.setState({ qty: e.target.value })}
                                                                                                label="Qty"
                                                                                                fullWidth={true}
                                                                                                style={{ marginTop: '10px', width: '100%' }}
                                                                                                inputProps={{
                                                                                                    name: 'age',
                                                                                                    id: 'outlined-age-native-simple',
                                                                                                }}
                                                                                            >
                                                                                                <option value={0.5}>0.5</option>
                                                                                                <option value={1}>1</option>
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                    </Box>
                                                                                </Box>
                                                                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                                                    <Box marginLeft={'5px'}>{this.state.isCommentsAdd ? <Box><DoneIcon color='primary' onClick={() => this.assignNewLeave(task, date, popupState)} /><CloseIcon color='secondary' onClick={() => { popupState.close(); this.setState({ description: '' }) }} /></Box> : <EditIcon color='primary' onClick={() => this.setState({ qty: task.leaves.find(user => user.date === date).quantity, isCommentsAdd: true })} />}</Box>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    </Popover>
                                                                </div>
                                                            )}
                                                        </PopupState>
                                                    </TableCell>
                                                }
                                                )}
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    }
                </DialogContent>
            </Dialog>
        </TableRow >
        )
    }
}

export default withSnackbar(withStyles(useStyles)(EmployeeRow));
